// extracted by mini-css-extract-plugin
export default {"container":"EmojiList_container__hLN34","list":"EmojiList_list__k1NqK","button":"EmojiList_button__DKtF+"};